import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";
import Protected from "@/components/Protected";

// Shell pages still reachable outside the retired /patient/* portal.
const DoctorList          = lazy(() => import("@/pages/DoctorList"));

// Legacy onboarding + patient-only workflows.
const StayConfirm         = lazy(() => import("@/pages/StayConfirm"));
const PatientWelcome      = lazy(() => import("@/pages/PatientWelcome"));
const Triage              = lazy(() => import("@/pages/Triage"));
const TriageChoice        = lazy(() => import("@/pages/TriageChoice"));
const EmergencyScreen     = lazy(() => import("@/pages/EmergencyScreen"));
const BookAppointment     = lazy(() => import("@/pages/BookAppointment"));
const Care                = lazy(() => import("@/pages/Care"));
const Dependants          = lazy(() => import("@/pages/Dependants"));
const Payment             = lazy(() => import("@/pages/Payment"));
const MockCheckout        = lazy(() => import("@/pages/MockCheckout"));
const PaymentSuccess      = lazy(() => import("@/pages/PaymentSuccess"));
const PaymentCancel       = lazy(() => import("@/pages/PaymentCancel"));
const PatientFulfilment   = lazy(() => import("@/pages/PatientFulfilment"));
const CareFinder          = lazy(() => import("@/pages/CareFinder"));
const NotificationPrefs   = lazy(() => import("@/pages/NotificationPrefs"));

// Guest concierge workspace (lux-styled /guest/* namespace).
const GuestNow            = lazy(() => import("@/pages/guest/GuestNow"));
const GuestGetCare        = lazy(() => import("@/pages/guest/GuestGetCare"));
const GuestMyCare         = lazy(() => import("@/pages/guest/GuestMyCare"));
const GuestAccount        = lazy(() => import("@/pages/guest/GuestAccount"));
const GuestConsultations  = lazy(() => import("@/pages/guest/GuestConsultations"));
const GuestPrescriptions  = lazy(() => import("@/pages/guest/GuestPrescriptions"));
const GuestLabs           = lazy(() => import("@/pages/guest/GuestLabs"));
const GuestIntake         = lazy(() => import("@/pages/guest/GuestIntake"));
const GuestMessages       = lazy(() => import("@/pages/guest/GuestMessages"));
const GuestBilling        = lazy(() => import("@/pages/guest/GuestBilling"));
const GuestRecords        = lazy(() => import("@/pages/guest/GuestRecords"));

const P = ["patient"];

export default (
  <>
    {/* Retired legacy /patient/* portal → redirected into the /guest workspace
       for a single guest experience. */}
    <Route path="/patient/home"          element={<Navigate to="/guest" replace />} />
    <Route path="/patient/doctors"       element={<Navigate to="/doctors" replace />} />
    <Route path="/patient/appointments"  element={<Navigate to="/guest/consultations" replace />} />
    <Route path="/patient/messages"      element={<Navigate to="/guest/messages" replace />} />
    <Route path="/patient/records"       element={<Navigate to="/guest/records" replace />} />
    <Route path="/patient/prescriptions" element={<Navigate to="/guest/prescriptions" replace />} />
    <Route path="/patient/lab-orders"    element={<Navigate to="/guest/labs" replace />} />
    <Route path="/patient/results"       element={<Navigate to="/guest/labs" replace />} />
    <Route path="/patient/payments"      element={<Navigate to="/guest/billing" replace />} />
    <Route path="/patient/profile"       element={<Navigate to="/guest/intake" replace />} />
    <Route path="/guest/home"            element={<Navigate to="/guest" replace />} />

    {/* Legacy onboarding & workflows */}
    <Route path="/stay/confirm"          element={<Protected roles={P}><StayConfirm /></Protected>} />
    <Route path="/welcome"               element={<Protected roles={P}><PatientWelcome /></Protected>} />
    <Route path="/triage"                element={<Protected roles={P}><Triage /></Protected>} />
    <Route path="/triage/choice"         element={<Protected roles={P}><TriageChoice /></Protected>} />
    <Route path="/emergency"             element={<Protected roles={P}><EmergencyScreen /></Protected>} />
    <Route path="/doctors"               element={<Protected roles={P}><DoctorList /></Protected>} />
    <Route path="/book/:doctorId"        element={<Protected roles={P}><BookAppointment /></Protected>} />
    <Route path="/care/:appointmentId"   element={<Protected roles={P}><Care /></Protected>} />
    <Route path="/records"               element={<Navigate to="/guest" replace />} />
    <Route path="/dependants"            element={<Protected roles={P}><Dependants /></Protected>} />
    <Route path="/payment/mock-checkout" element={<Protected roles={P}><MockCheckout /></Protected>} />
    <Route path="/payment/:appointmentId" element={<Protected roles={P}><Payment /></Protected>} />
    <Route path="/payment/success"       element={<Protected roles={P}><PaymentSuccess /></Protected>} />
    <Route path="/payment/cancel"        element={<Protected roles={P}><PaymentCancel /></Protected>} />
    <Route path="/fulfilment"            element={<Protected roles={P}><PatientFulfilment /></Protected>} />
    <Route path="/care/finder"           element={<Protected roles={P}><CareFinder /></Protected>} />
    <Route path="/settings/notifications" element={<Protected roles={P}><NotificationPrefs /></Protected>} />

    {/* Guest concierge workspace — five sections: Now / Get care / My care /
       Health file / Account (see lib/guestNav.js) */}
    <Route path="/guest"                 element={<Protected roles={P}><GuestNow /></Protected>} />
    <Route path="/guest/care"            element={<Protected roles={P}><GuestGetCare /></Protected>} />
    <Route path="/guest/my-care"         element={<Protected roles={P}><GuestMyCare /></Protected>} />
    <Route path="/guest/account"         element={<Protected roles={P}><GuestAccount /></Protected>} />
    <Route path="/guest/consultations"   element={<Protected roles={P}><GuestConsultations /></Protected>} />
    <Route path="/guest/consult/:appointmentId" element={<Protected roles={P}><Care /></Protected>} />
    <Route path="/guest/intake"          element={<Protected roles={P}><GuestIntake /></Protected>} />
    <Route path="/guest/messages"        element={<Protected roles={P}><GuestMessages /></Protected>} />
    <Route path="/guest/billing"         element={<Protected roles={P}><GuestBilling /></Protected>} />
    <Route path="/guest/prescriptions"   element={<Protected roles={P}><GuestPrescriptions /></Protected>} />
    <Route path="/guest/labs"            element={<Protected roles={P}><GuestLabs /></Protected>} />
    <Route path="/guest/records"         element={<Protected roles={P}><GuestRecords /></Protected>} />
  </>
);
